import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../../../components/ui';
import cn from '../../../../../../components/ui/utils/cn';
import styles from './ModalitySlide.module.css';

function ModalitySlide({ title, body, knowMoreHref, capitalize }) {
  const { t } = useTranslation('home');

  const bodyLines = t(body)
    .replace(/([.!])\s+/g, '$1\n')
    .split('\n');

  return (
    <div className={styles.root}>
      <h3 className={cn(styles.title, capitalize && styles.capitalize)}>
        {t(title)}
      </h3>
      <div className={styles.body}>
        {bodyLines.map((line, i) => (
          <p key={i} className={styles.bodyLine}>
            {line}
          </p>
        ))}
      </div>
      <div className={styles.actions}>
        {knowMoreHref && (
          <Button
            variant='outline'
            size='md'
            className={styles.actionKnowMore}
            as={Link}
            to={knowMoreHref}>
            {t('SUPPLIER_KNOW_MORE')}
          </Button>
        )}
        <Button
          variant='primary'
          size='md'
          className={styles.actionSupplier}
          as={Link}
          to='/homologado'>
          {t('I_WANT_TO_BE_SUPPLIER')}
        </Button>
      </div>
    </div>
  );
}

ModalitySlide.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  knowMoreHref: PropTypes.string,
  capitalize: PropTypes.bool
};

export default ModalitySlide;
